(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["colecciones-animadas"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ftc-animated-collections')) {
    customElements.define('ftc-animated-collections', class extends HTMLElement {
      connectedCallback() {
        if (this._controller) return;
        this._controller = new AbortController();
        const options = { signal: this._controller.signal };
        this._reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this._touch = matchMedia('(hover: none), (pointer: coarse)');
        this._paused = false;
        this._cards = [...this.querySelectorAll('[data-ftcg-card][data-video]')];
        this._visible = new Set(); this._hovered = new Set(); this._focused = new Set();
        this._button = this.querySelector('.ftcg__motion');
        this._button.hidden = !this._cards.length;
        this._button.addEventListener('click', () => {
          this._paused = !this._paused;
          this._button.setAttribute('aria-pressed', String(this._paused));
          this._button.textContent = this._paused ? this._button.dataset.resume : this._button.dataset.pause;
          this._sync();
        }, options);
        this._cards.forEach(card => {
          card.addEventListener('pointerenter', event => {if (event.pointerType !== 'touch') { this._hovered.add(card); this._sync(); }}, options);
          card.addEventListener('pointerleave', () => {this._hovered.delete(card);this._sync();}, options);
          card.addEventListener('focusin', () => {this._focused.add(card);this._sync();}, options);
          card.addEventListener('focusout', () => {this._focused.delete(card);this._sync();}, options);
        });
        this._reduced.addEventListener('change', () => this._sync(), options);
        this._touch.addEventListener('change', () => {this._hovered.clear();this._sync();}, options);
        document.addEventListener('visibilitychange', () => this._sync(), options);
        if ('IntersectionObserver' in window) {
          this._observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (entry.isIntersecting && entry.intersectionRatio >= 0.35) this._visible.add(entry.target);
              else this._visible.delete(entry.target);
            });
            this._sync();
          }, {threshold:[0,0.35,0.65,1]});
          this._cards.forEach(card => this._observer.observe(card));
        } else {
          this._cards.forEach(card => this._visible.add(card));
        }
      }
      _sync() {
        const allowed = !this._paused && !this._reduced.matches && !document.hidden;
        this._cards.forEach(card => {
          const active = allowed && this._visible.has(card) &&
            (this._touch.matches ? this.dataset.autoplay === 'true' : this.dataset.desktopAutoplay === 'true' || this._hovered.has(card) || this._focused.has(card));
          if (active) this._start(card); else this._stop(card);
        });
      }
      _start(card) {
        if (card.dataset.videoFailed || card._videoWanted) return;
        const layer = card.querySelector('.ftcg__animation');
        let video = layer.querySelector('video');
        if (!video) {
          layer.appendChild(card.querySelector('[data-video-template]').content.cloneNode(true));
          video = layer.querySelector('video');
          video.muted = true; video.defaultMuted = true; video.playsInline = true;
          video.addEventListener('playing', () => {
            if (card._videoWanted) card.classList.add('is-playing');
            else video.pause();
          }, {signal:this._controller.signal});
          video.addEventListener('error', () => {
            card.dataset.videoFailed = 'true'; this._stop(card);
          }, {signal:this._controller.signal});
        }
        card._videoWanted = true;
        video.play().catch(() => {
          if (video.paused) {card._videoWanted = false; card.classList.remove('is-playing');}
        });
      }
      _stop(card) {
        card._videoWanted = false;
        card.classList.remove('is-playing');
        card.querySelector('.ftcg__animation video')?.pause();
      }
      disconnectedCallback() {
        this._observer?.disconnect();
        this._controller?.abort();
        this._cards?.forEach(card => this._stop(card));
        this._cards?.forEach(card => {
          const layer = card.querySelector('.ftcg__animation');
          const video = layer.querySelector('video');
          if (video) {video.removeAttribute('src');video.querySelectorAll('source').forEach(source=>source.removeAttribute('src'));video.load();}
          layer.replaceChildren();
        });
        this._controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
  const getpagi = document.querySelector('.AjaxinatePagination');

  if (typeof(getpagi) !== "undefined" && getpagi !== null) {
    document.addEventListener("DOMContentLoaded", function() {
      const elem = getpagi.getAttribute('data-pagination');

      var endlessScroll = new Ajaxinate({
        container: '.AjaxinateLoop',
        pagination: '.AjaxinatePagination',
        loadingText: '<span class="loader-line"></span>',
        method: elem == 'scroll' ? 'scroll' : 'click'
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function() {
    const links = document.querySelectorAll('.collection-card-3 a[href="#"]');

    links.forEach(link => {
      const card = link.closest('.collection-card-3');

      if (card) {
        card.style.display = 'none';
      }
    });
  });

  function ftcParseRgb(value) {
    if (!value) return null;

    var match = value.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([0-9.]+))?\)/);

    if (!match) return null;

    return {
      r: parseInt(match[1], 10),
      g: parseInt(match[2], 10),
      b: parseInt(match[3], 10),
      a: match[4] !== undefined ? parseFloat(match[4]) : 1
    };
  }

  function ftcCompressionLevelFromText(text) {
    var value = (text || '').trim().toLowerCase();

    if (value === 'baja' || value === 'baja compresión' || value === 'low' || value === 'low compression') {
      return 'baja';
    }

    if (value === 'media' || value === 'media compresión' || value === 'medium' || value === 'medium compression') {
      return 'media';
    }

    if (value === 'alta' || value === 'alta compresión' || value === 'high' || value === 'high compression') {
      return 'alta';
    }

    return '';
  }

  function ftcRemoveOldCompressionClasses(scope) {
    if (!scope) return;

    var oldClasses = [
      'ftc-compression-label',
      'ftc-compression-label--alta',
      'ftc-compression-label--media',
      'ftc-compression-label--baja',
      'ftc-compression-label--high',
      'ftc-compression-label--medium',
      'ftc-compression-label--low',
      'ftc-compression-soft-label',
      'ftc-compression-soft-label--alta',
      'ftc-compression-soft-label--media',
      'ftc-compression-soft-label--baja',
      'ftc-compression-segment',
      'ftc-compression-segment--active',
      'ftc-compression-segment--inactive',
      'ftc-compression-segment--alta',
      'ftc-compression-segment--media',
      'ftc-compression-segment--baja',
      'ftc-compression-segment--high',
      'ftc-compression-segment--medium',
      'ftc-compression-segment--low',
      'ftc-compression-choice',
      'ftc-compression-choice--active',
      'ftc-compression-choice--inactive',
      'ftc-compression-choice--baja',
      'ftc-compression-choice--media',
      'ftc-compression-choice--alta'
    ];

    scope.querySelectorAll('*').forEach(function(el) {
      oldClasses.forEach(function(className) {
        el.classList.remove(className);
      });
    });
  }

  function ftcElementHasActiveState(el, boundary) {
    var node = el;

    while (node && node !== boundary && node.nodeType === 1) {
      var className = '';

      if (typeof node.className === 'string') {
        className = node.className.toLowerCase();
      } else if (node.className && typeof node.className.baseVal === 'string') {
        className = node.className.baseVal.toLowerCase();
      }

      if (/active|selected|current|checked|is-active/.test(className)) {
        return true;
      }

      if (
        node.getAttribute('aria-selected') === 'true' ||
        node.getAttribute('aria-pressed') === 'true' ||
        node.getAttribute('data-active') === 'true' ||
        node.getAttribute('data-selected') === 'true'
      ) {
        return true;
      }

      node = node.parentElement;
    }

    return false;
  }

  function ftcElementLooksOriginallyActive(el) {
    if (!el) return false;

    var computed = window.getComputedStyle(el);
    var bg = ftcParseRgb(computed.backgroundColor);
    var color = ftcParseRgb(computed.color);

    if (!bg || bg.a === 0) return false;

    var looksRed = bg.r >= 120 && bg.g <= 110 && bg.b <= 130;
    var looksDark = bg.r <= 90 && bg.g <= 90 && bg.b <= 90;
    var textLooksLight = color && color.r >= 200 && color.g >= 200 && color.b >= 200;

    return looksRed || (looksDark && textLooksLight);
  }

  function ftcFindCompressionElements(item) {
    var candidates = item.querySelectorAll('span, small, a, button, li, div');
    var found = [];

    candidates.forEach(function(el) {
      if (el.children && el.children.length > 0) return;

      var level = ftcCompressionLevelFromText(el.textContent);

      if (!level) return;

      found.push({
        element: el,
        level: level
      });
    });

    return found;
  }

  function ftcFindCompressionGroup(item, compressionItems) {
    if (!compressionItems || compressionItems.length < 2) return null;

    var first = compressionItems[0].element;
    var node = first.parentElement;

    while (node && node !== item) {
      var text = node.textContent.toLowerCase();
      var hasBaja = text.indexOf('baja') !== -1 || text.indexOf('low') !== -1;
      var hasMedia = text.indexOf('media') !== -1 || text.indexOf('medium') !== -1;
      var hasAlta = text.indexOf('alta') !== -1 || text.indexOf('high') !== -1;

      if ((hasBaja && hasMedia) || (hasBaja && hasAlta) || (hasMedia && hasAlta)) {
        return node;
      }

      node = node.parentElement;
    }

    return first.parentElement;
  }

  function ftcStyleCompressionActiveOnly(item) {
    if (!item) return;

    ftcRemoveOldCompressionClasses(item);

    var compressionItems = ftcFindCompressionElements(item);

    if (!compressionItems || compressionItems.length < 2) return;

    var group = ftcFindCompressionGroup(item, compressionItems);

    if (!group) return;

    var activeItem = null;

    compressionItems.forEach(function(entry) {
      if (!activeItem && ftcElementHasActiveState(entry.element, group)) {
        activeItem = entry;
      }
    });

    compressionItems.forEach(function(entry) {
      if (!activeItem && ftcElementLooksOriginallyActive(entry.element)) {
        activeItem = entry;
      }
    });

    group.classList.add('ftc-compression-group-fixed');

    compressionItems.forEach(function(entry) {
      entry.element.classList.add('ftc-compression-choice');
      entry.element.classList.add('ftc-compression-choice--' + entry.level);
    });

    if (activeItem && activeItem.element) {
      activeItem.element.classList.add('ftc-compression-choice--active');
    }
  }

  function ftcApplyProductStageLabels() {
    var productItems = document.querySelectorAll('[data-ftc-grid-product-item]');

    productItems.forEach(function(item) {
      var target =
        item.querySelector('.card__information') ||
        item.querySelector('.card-information') ||
        item.querySelector('.product-card__info') ||
        item.querySelector('.product-card__content') ||
        item.querySelector('.product-item__info') ||
        item.querySelector('.product-card') ||
        item.querySelector('.card__content') ||
        item;

      var source = item.querySelector('[data-ftc-product-stage-source]');

      if (source && target && !target.querySelector('.ftc-product-stage-row')) {
        var row = document.createElement('div');
        row.className = 'ftc-product-stage-row';
        row.innerHTML = source.innerHTML;

        var swatchTarget =
          target.querySelector('.color-swatch') ||
          target.querySelector('.swatch') ||
          target.querySelector('.product-card__swatches') ||
          target.querySelector('.card__swatches');

        var titleTarget =
          target.querySelector('.card__heading') ||
          target.querySelector('.product-card__title') ||
          target.querySelector('.product-card-title') ||
          target.querySelector('h3') ||
          target.querySelector('h4');

        if (swatchTarget && swatchTarget.parentNode) {
          swatchTarget.parentNode.insertBefore(row, swatchTarget);
        } else if (titleTarget && titleTarget.parentNode) {
          titleTarget.insertAdjacentElement('afterend', row);
        } else {
          target.insertBefore(row, target.firstChild);
        }
      }

      ftcStyleCompressionActiveOnly(item);
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    ftcApplyProductStageLabels();

    setTimeout(function() {
      ftcApplyProductStageLabels();
    }, 400);

    setTimeout(function() {
      ftcApplyProductStageLabels();
    }, 1200);

    var productGrid = document.querySelector('#product-grid');

    if (productGrid) {
      var observer = new MutationObserver(function() {
        ftcApplyProductStageLabels();
      });

      observer.observe(productGrid, {
        childList: true,
        subtree: true
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
            if (window.SPR && theme.review ) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              };
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    

var initPhotoSwipeFromDOM = function(gallerySelector) {

// parse slide data (url, title, size ...) from DOM elements 
// (children of gallerySelector)
var parseThumbnailElements = function(el) {
  var thumbElements = Array.prototype.slice.call(document.querySelectorAll('.photo-image')),
    numNodes = thumbElements.length,
    items = [],
    figureEl,
    linkEl,
    size,
    item;

  for (var i = 0; i < numNodes; i++) {

    figureEl = thumbElements[i]; // <figure> element
    // include only element nodes 
    if (figureEl.nodeType !== 1) {
      continue;
    }

    linkEl = figureEl.children[0]; // <a> element
    if(linkEl.getAttribute('data-size')){
      size =  linkEl.getAttribute('data-size').split('x') ;
    }else{
      size =  [] ;
    }
    
    

    // create slide object
    item = {
      src: linkEl.getAttribute('href'),
      w: parseInt(size[0], 10),
      h: parseInt(size[1], 10)
    };



    if (figureEl.children.length > 1) {
      // <figcaption> content
      item.title = figureEl.children[1].innerHTML;
    }

    if (linkEl.children.length > 0) {
      // thumbnail element, retrieving thumbnail url
      item.msrc = linkEl.children[0].getAttribute('src');
    }

    item.el = figureEl; // save link to element for getThumbBoundsFn
    items.push(item);
  }

  return items;
};

// find nearest parent element
var closest = function closest(el, fn) {
  return el && (fn(el) ? el : closest(el.parentNode, fn));
};

// triggers when user clicks on thumbnail
var onThumbnailsClick = function(e) {
  e = e || window.event;
  e.preventDefault ? e.preventDefault() : e.returnValue = false;

  var eTarget = e.target || e.srcElement;

  // find root element of slide
  var clickedListItem = closest(eTarget, function(el) {
    return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
  });

  if (!clickedListItem) {
    return;
  }

  // find index of clicked item by looping through all child nodes
  // alternatively, you may define index via data- attribute
  var clickedGallery = clickedListItem.parentNode,
    childNodes = clickedListItem.parentNode.childNodes,
    numChildNodes = childNodes.length,
    nodeIndex = 0,
    index;

  for (var i = 0; i < numChildNodes; i++) {
    if (childNodes[i].nodeType !== 1) {
      continue;
    }

    if (childNodes[i] === clickedListItem) {
      index = nodeIndex;
      break;
    }
    nodeIndex++;
  }



  if (index >= 0) {
    // open PhotoSwipe if valid index found
    openPhotoSwipe(index, clickedGallery);
  }
  return false;
};

// parse picture index and gallery index from URL (#&pid=1&gid=2)
var photoswipeParseHash = function() {
  var hash = window.location.hash.substring(1),
    params = {};

  if (hash.length < 5) {
    return params;
  }

  var vars = hash.split('&');
  for (var i = 0; i < vars.length; i++) {
    if (!vars[i]) {
      continue;
    }
    var pair = vars[i].split('=');
    if (pair.length < 2) {
      continue;
    }
    params[pair[0]] = pair[1];
  }

  if (params.gid) {
    params.gid = parseInt(params.gid, 10);
  }

  return params;
};

var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
  var pswpElement = document.querySelectorAll('.pswp')[0],
    gallery,
    options,
    items;

  items = parseThumbnailElements(galleryElement);

  // define options (if needed)
  options = {
    maxSpreadZoom: 1, 
    bgOpacity: 0.7,
    zoomEl: true,
    history: false,
    pinchToClose: false,
    closeOnScroll: false,

    // define gallery index (for URL)
    galleryUID: galleryElement.getAttribute('data-pswp-uid'),

  };

  // PhotoSwipe opened from URL
  if (fromURL) {
    if (options.galleryPIDs) {
      // parse real index when custom PIDs are used 
      // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
      for (var j = 0; j < items.length; j++) {
        if (items[j].pid == index) {
          options.index = j;
          break;
        }
      }
    } else {
      // in URL indexes start from 1
      options.index = parseInt(index, 10) - 1;
    }
  } else {
    options.index = parseInt(index, 10);
  }

  // exit if index not found
  if (isNaN(options.index)) {
    return;
  }

  if (disableAnimation) {
    options.showAnimationDuration = 0;
  }

  // Pass data to PhotoSwipe and initialize it
  gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
  gallery.init();
};

// loop through all gallery elements and bind events
var galleryElements = document.querySelectorAll(gallerySelector);

for (var i = 0, l = galleryElements.length; i < l; i++) {
  galleryElements[i].setAttribute('data-pswp-uid', i + 1);
  galleryElements[i].onclick = onThumbnailsClick;
}

// Parse URL and open gallery if it contains #&pid=3&gid=1
var hashData = photoswipeParseHash();
if (hashData.pid && hashData.gid) {
  openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
}
};

// execute above function
initPhotoSwipeFromDOM('.my-gallery');


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonios-video"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ftc-video-stories'))customElements.define('ftc-video-stories',class extends HTMLElement{
 connectedCallback(){
  if(this.ctrl)return;this.ctrl=new AbortController();const opts={signal:this.ctrl.signal};
  this.dialog=this.querySelector('dialog');this.content=this.querySelector('.ftcs__dialog-content');this.track=this.querySelector('.ftcs__track');this.videos=[...this.querySelectorAll('video')];this.visible=new Set();this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
  this.videos.forEach(video=>{const poster=video.parentElement.querySelector('[data-poster]');if(poster)video.poster=poster.dataset.poster;video.muted=true;});
  this.addEventListener('click',event=>{
   const open=event.target.closest('[data-open]');if(open&&typeof this.dialog.showModal==='function'){event.preventDefault();this.openProduct(open);return;}
   if(event.target.closest('.ftcs__close'))this.dialog.close();
   const nav=event.target.closest('[data-direction]');if(nav){const card=this.track.querySelector('.ftcs__card');if(card)this.track.scrollBy({left:Number(nav.dataset.direction)*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).gap)),behavior:this.reduced.matches?'instant':'smooth'});}
   const thumb=event.target.closest('[data-image]');if(thumb&&thumb.tagName==='BUTTON')this.setImage(thumb.dataset.image,thumb.dataset.alt);
  },opts);
  this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();}},opts);
  this.dialog.addEventListener('close',()=>this.cleanupModal(),opts);
  this.addEventListener('change',e=>{if(e.target.matches('[data-variant]'))this.updateVariant();},opts);
  this.addEventListener('submit',e=>{if(e.target.matches('.ftcs__form')){e.stopPropagation();const button=e.target.querySelector('[type="submit"]');button.disabled=true;button.textContent='…';}},opts);
  document.addEventListener('visibilitychange',()=>{if(document.hidden)this.videos.forEach(v=>v.pause());},opts);
  this.reduced.addEventListener('change',()=>{if(this.reduced.matches)this.videos.forEach(v=>v.pause());},opts);
  if('IntersectionObserver'in window){this.observer=new IntersectionObserver(entries=>entries.forEach(entry=>{const video=entry.target;if(entry.isIntersecting&&entry.intersectionRatio>=.6){this.visible.add(video);if(this.dataset.autoplay==='true'&&!this.reduced.matches&&!document.hidden&&!this.dialog.open)video.play().catch(()=>{});}else{this.visible.delete(video);video.pause();}}),{threshold:[0,.6]});this.videos.forEach(v=>this.observer.observe(v));}
  const updateNav=()=>{const max=this.track.scrollWidth-this.track.clientWidth;this.querySelector('[data-direction="-1"]').disabled=this.track.scrollLeft<=2;this.querySelector('[data-direction="1"]').disabled=this.track.scrollLeft>=max-2;};
  this.track.addEventListener('scroll',updateNav,opts);if('ResizeObserver'in window){this.resize=new ResizeObserver(updateNav);this.resize.observe(this.track);}updateNav();
 }
 openProduct(trigger){const template=this.querySelector(`[id="${CSS.escape(trigger.dataset.open)}"]`);if(!template)return;
  this.returnFocus=trigger;this.videos.forEach(v=>v.pause());this.content.replaceChildren(template.content.cloneNode(true));this.dialog.setAttribute('aria-labelledby',this.content.querySelector('h3').id);this.updateVariant();
  this.oldOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';this.locked=true;this.dialog.showModal();this.dialog.querySelector('.ftcs__close').focus();
 }
 setImage(src,alt){const img=this.content.querySelector('.ftcs__hero');if(img&&src){img.src=src;img.alt=alt||'';}}
 updateVariant(){const select=this.content.querySelector('[data-variant]');if(!select)return;const option=select.selectedOptions[0];if(!option)return;const d=option.dataset;
  this.content.querySelector('[data-price]').textContent=d.price;const compare=this.content.querySelector('[data-compare]');compare.textContent=d.compare;compare.hidden=!d.compare;
  const button=this.content.querySelector('[type="submit"]');button.disabled=d.available!=='true';button.textContent=button.disabled?button.dataset.sold:button.dataset.add;
  const quantity=this.content.querySelector('[name="quantity"]');quantity.min=d.min||'1';quantity.step=d.step||'1';quantity.value=quantity.min;if(d.max)quantity.max=d.max;else quantity.removeAttribute('max');
  this.setImage(d.image,d.alt);const link=this.content.querySelector('[data-details-link]');if(link){const url=new URL(link.href,location.origin);url.searchParams.set('variant',option.value);link.href=url.href;}
 }
 cleanupModal(){if(this.locked){document.documentElement.style.overflow=this.oldOverflow;this.locked=false;}this.content.replaceChildren();if(this.returnFocus?.isConnected)this.returnFocus.focus();}
 disconnectedCallback(){this.observer?.disconnect();this.resize?.disconnect();this.videos?.forEach(v=>v.pause());if(this.dialog?.open)this.dialog.close();this.cleanupModal();this.ctrl?.abort();this.ctrl=null;}
});

  } catch(e) { console.error(e); }
})();
})();
